export const LISTE_TYPE_OT = {
  title: 'Liste de types d\'OT technique',
  actions: {
    add: 'Nouveau type d\'OT technique',
  },
  filtre: {
    types: 'Type(s)',
    actionInterventions: 'Action(s) intervention',
    produit: 'Produit(s)',
  },
  breadcrumb: {
    listeTypeOt: 'Liste types OT technique',
  },
  tab: {
    type: 'Type',
    actionIntervention: 'Action intervention',
    produit: 'Produit',
    taches: 'Nb tâches',
    isVisibleInSuiviProduction: 'Visible dans suivi de production',
  },
  actionIntervention: {
    montage: 'Montage',
    demontage: 'Démontage',
    aucun: 'Aucun',
    impressionAffiche: 'Impression d\'affiche',
    fabricationDipositif: 'Fabrication du dispositif',
    poseDispositifFabrique: 'Pose du dispositif fabriqué',
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer ce type d\'OT ?',
  },
  messages: {
    success: {
      typeOtDelete: 'Type d\'OT supprimé avec succès',
    },
    error: {
      typeOtAlreadyUseOt: 'Le type d\'OT ne peut pas être supprimé car il est utilisé dans un OT technique',
      typeOtAlreadyUseDemande: 'Le type d\'OT ne peut pas être supprimé car il est utilisé dans une demande d\'intervention',
    },
  },
};

export const DETAIL_TYPE_OT = {
  title: 'Détail type OT technique {libelle}',
  breadcrumb: {
    typeOt: 'Liste types OT technique',
    detailTypeOt: 'Détail type OT technique',
  },
  informations: {
    title: 'Informations générales',
    type: 'Type :',
    actionIntervention: 'Action intervention :',
    produit: 'Produit :',
    isVisibleInSuiviProduction: 'Visible dans suivi de production',
    couleur: 'Couleur',
  },
  noTaches: 'Aucune tâche ajoutée',
  tab: {
    libelle: 'Libellé',
    description: 'Description',
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer ce type d\'OT ?',
  },
};

export const ADD_EDIT_TYPE_OT = {
  title: {
    add: 'Ajouter un type d\'OT technique',
    edit: 'Modifier le type d\'OT technique: {nom}',
  },
  breadcrumb: {
    liste: 'Liste types OT technique',
    edit: 'Modifier type OT technique',
    add: 'Ajouter type OT technique',
  },
  errors: {
    libelle: 'Libellé',
    actionIntervention: 'Action intervention',
    libelleTache: 'Titre de la tâche',
    libelleDescription: 'Description de la tâche',
  },
  success: {
    add: 'Le Type d\'OT technique a été ajouté avec succès.',
    edit: 'Le type d\'OT technique a été modifié avec succès.',
  },
  infoGenerale: {
    title: 'Informations génerales',
    libelle: 'Libellé',
    actionIntervention: 'Action intervention',
    produit: 'Produit',
    isVisibleInSuiviProduction: 'Visible dans suivi de production',
    couleur: 'Couleur',
  },
  addEditTaches: {
    title: 'Liste des tâches',
    libelle: 'Titre',
    description: 'Description',
    action: {
      add: 'Ajouter une tâche',
    },
  },
};
